// extracted by mini-css-extract-plugin
export default {"modalBackground":"AdminJobOfferView_modalBackground__7YF5K","modalContent":"AdminJobOfferView_modalContent__PfWam"};